/* TODO: t() */
import React, { Fragment, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';

import { Text, TextInput } from '../../../uiold';

import { useBuilderState } from '../../BuilderContext';

import { TextInputElementDefinition } from '../../../../types/shared/EvaluationForm';
import { FormElementProps } from '../../types';

type Props = FormElementProps<TextInputElementDefinition>;

function TextInputElementBuilderView(props: Props) {
  let { definition, sortIndex } = props;
  let { activeFieldId, update } = useBuilderState();

  let isActive = definition.id === activeFieldId;

  let onQuestionChange = useCallback(
    (text: string) =>
      update((draft) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        draft.fields[sortIndex]!.question = text;
      }),
    [sortIndex, update],
  );
  let onLabelChange = useCallback(
    (text: string) =>
      update((draft) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        draft.fields[sortIndex]!.label = text;
      }),
    [sortIndex, update],
  );

  return (
    <Fragment>
      {isActive ? (
        <View style={styles.row}>
          <TextInput
            autoFocus
            selectOnFocus
            style={styles.question}
            placeholder="Question"
            value={definition.question}
            onChangeText={onQuestionChange}
          />
          <TextInput
            // TODO: Add label usage explanation
            style={styles.label}
            placeholder="Label"
            value={definition.label}
            onChangeText={onLabelChange}
          />
        </View>
      ) : (
        <View style={styles.row}>
          <Text style={styles.question}>
            {definition.question || 'Question'}
          </Text>
          {!!definition.label && (
            <Text style={styles.label}>{`(${definition.label})`}</Text>
          )}
        </View>
      )}
    </Fragment>
  );
}

let styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  question: {
    cursor: 'text',
    // Bootstrap CSS is overriding this font size for text input.
    fontSize: 16,
    lineHeight: 34,
  },
  label: {
    marginLeft: 8,
    maxWidth: 100,
    textAlign: 'right',
  },
});

export default TextInputElementBuilderView;
